import { ApplicationSetupPage } from '@page/application-setup/application-setup.page';
import { OverviewPage } from '@page/overview/overview.page';

import { ApplicationStepsAside } from '@component/aside/application-steps/application-steps.aside';
import { EmptyNavigationAside } from '@component/aside/navigation/empty-navigation.aside';
import { Header } from '@component/header/header';
import { RouteEnum } from '@enum/route.enum';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { pageNameLoader } from '@util/route/page-name-loader';

export const ApplicationsRoutes: RouteConfigInterface[] = [
  {
    ...pageNameLoader(RouteEnum.Overview),
    Component: OverviewPage,
    Aside: EmptyNavigationAside,
    Header,
  },
  {
    Aside: () => <ApplicationStepsAside />,
    Component: ApplicationSetupPage,
    ...pageNameLoader(RouteEnum.ApplicationSetup),
  },
  {
    Aside: () => <ApplicationStepsAside step={1} />,
    Component: ApplicationSetupPage,
    ...pageNameLoader(RouteEnum.ApplicationSetupConnectors),
  },
  {
    Aside: () => <ApplicationStepsAside step={2} />,
    Component: ApplicationSetupPage,
    ...pageNameLoader(RouteEnum.ApplicationSetupConsumer),
  },
  {
    Aside: () => <ApplicationStepsAside step={3} />,
    Component: ApplicationSetupPage,
    ...pageNameLoader(RouteEnum.ApplicationSetupNext),
  },
];
